export default __webpack_public_path__ + "static/media/pic5.26a41a0b.jpg";